module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    attrs: {
      "id": "titleName"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#00A5D5"
    }
  }, [_vm._v(_vm._s(_vm.secTitle))]), _vm._v(" "), (_vm.content != '') ? _c('span', [_vm._v("（" + _vm._s(_vm.content) + "）")]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "orderUpload"
  }, _vm._l((_vm.list), function(item, i) {
    return _c('el-upload', {
      key: i,
      staticClass: "tempUpload",
      style: (_vm.draggerStyle),
      attrs: {
        "drag": "",
        "action": "",
        "show-file-list": false,
        "before-upload": _vm.handleChange,
        "http-request": _vm.uploadFile,
        "multiple": "",
        "data": {
          objectType: _vm.dataType,
          objectTag: '',
          index: i
        },
        "auto-upload": true
      }
    }, [(_vm.dataList[i]) ? _c('i', {
      staticClass: "el-icon-close",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeFile(i)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.dataList[i]) ? _c('div', {
      staticClass: "removeIcon"
    }, [_c('i', {
      staticClass: "el-icon-check"
    })]) : _vm._e(), _vm._v(" "), (_vm.dataList[i]) ? _c('img', {
      staticClass: "avatar",
      attrs: {
        "src": _vm.dataList[i]
      }
    }) : _c('div', [_c('i', {
      staticClass: "el-icon-plus uploadIcon"
    }), _vm._v(" "), _c('div', {
      staticClass: "el-upload__text"
    }, [_c('em', [_vm._v(_vm._s(item.label))])])])])
  }), 1), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "example"
    },
    on: {
      "click": function($event) {
        _vm.isShow = !_vm.isShow
      }
    }
  }, [_vm._v("示例")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-fade-in-linear"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "item"
  }, _vm._l((_vm.list), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "example",
      style: ({
        marginLeft: _vm.distance + '%'
      })
    }, [_c('img', {
      staticClass: "exampleImg",
      style: ({
        width: _vm.imgWidth + 'px',
        height: _vm.imgHeight + 'px'
      }),
      attrs: {
        "src": item.imgUrl,
        "alt": "item.label"
      }
    }), _vm._v(" "), (_vm.list.length == 4 && _vm.isShow) ? _c('img', {
      staticClass: "copyright",
      style: (_vm.list.length == 5 ? 'bottom:50px;' : ''),
      attrs: {
        "src": "/static/images/orthodontics/smiling-orthodontics.jpg"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.list.length == 5 && _vm.isShow && ![0, 4].includes(i)) ? _c('img', {
      staticClass: "copyright",
      style: (_vm.list.length == 5 ? 'bottom:50px;' : ''),
      attrs: {
        "src": "/static/images/orthodontics/smiling-orthodontics.jpg"
      }
    }) : _vm._e()])
  }), 0)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ed6402f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Order/components/templateUpload.vue
// module id = 634
// module chunks = 0